<template>
  <div class="packing-scheme-container">
    <h6 class="m-0" style="color:#101010">
      {{ $l('title_base_info') }}
    </h6>
    <div class="base-info__form">
      <el-form
        v-if="!disabled"
        ref="form"
        :model="formData"
        :rules="rules"
        :disabled="disabled"
        size="mini"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="
                $l('form_label_evgPackingSchemeName') || '大货包装方案名称'
              "
              prop="evgPackingSchemeName"
            >
              <el-input
                v-model="formData.evgPackingSchemeName"
                :placeholder="
                  $l('form_placeholder_evgPackingSchemeName') ||
                    '请输入大货包装方案名称'
                "
                maxlength="100"
                show-word-limit
                clearable
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_salesPersonCode') || '业务人员'"
              prop="salesPersonCode"
            >
              <dict-select
                v-model="formData.salesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :selectedLabel.sync="formData.salesPersonName"
                :placeholder="
                  $l('form_placeholder_salesPersonCode') || '请选择业务人员'
                "
                clearable
                filterable
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_merchandiserCode') || '跟单'"
              prop="merchandiserCode"
            >
              <dict-select
                v-model="formData.merchandiserCode"
                url="/master/common/dict/baseUserSelect"
                :selectedLabel.sync="formData.merchandiserName"
                :placeholder="
                  $l('form_placeholder_merchandiserCode') || '请选择跟单'
                "
                clearable
                filterable
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_platformCode') || '渠道'"
              prop="platformCode"
            >
              <dict-select
                v-model="formData.platformCode"
                url="/ecom/evg/platform/select"
                :placeholder="
                  $l('form_placeholder_platformCode') || '请选择渠道'
                "
                filterable
                clearable
                size="mini"
                style="width:100%"
                @change="platformChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_cust') || '所属客户'">
              <el-input v-model="formData.custName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_ftyPersonCode') || '工厂跟单'"
              prop="ftyPersonCode"
            >
              <dict-select
                v-model="formData.ftyPersonCode"
                url="/master/common/dict/baseUserSelect"
                :selectedLabel.sync="formData.ftyPersonName"
                :placeholder="
                  $l('form_placeholder_ftyPersonCode') || '请选择工厂跟单'
                "
                size="mini"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$l('form_label_regionCode') || '货物运抵国'">
              <el-input v-model="formData.regionName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_dispatchPort') || '出运港口'"
              prop="dispatchPort"
            >
              <dict-select
                v-model="formData.dispatchPort"
                url="/master/port/select"
                :placeholder="
                  $l('form_placeholder_dispatchPort') || '请选择出运港口'
                "
                clearable
                filterable
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_bookingType') || '订舱类型'"
              prop="bookingType"
            >
              <dict-select
                v-model="formData.bookingType"
                :body="{ dictType: 'bookingType' }"
                url="/sys/common/dict/system"
                :placeholder="
                  $l('form_placeholder_bookingType') || '请输入订舱类型'
                "
                size="mini"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_containerName') || '出运箱型'"
              prop="containerName"
            >
              <dict-select
                v-model="formData.containerName"
                url="/ecom/master/container/select"
                :placeholder="
                  $l('form_placeholder_containerName') || '请输入出运箱型'
                "
                size="mini"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_inContainerQty') || '装柜入数'"
              prop="inContainerQty"
            >
              <el-input-number
                v-model="formData.inContainerQty"
                :placeholder="
                  $l('form_placeholder_inContainerQty') || '请输入装柜入数'
                "
                controls-position="right"
                :min="0"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_inContainerUnit') || '入柜单位'"
              prop="inContainerUnit"
            >
              <dict-select
                v-model="formData.inContainerUnit"
                :body="{ dictType: 'inContainerUnit' }"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('form_placeholder_inContainerUnit') || '请选择入柜单位'
                "
                size="mini"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="2">
            <el-form-item
              :label="$l('form_label_palletLength') || '单托长(cm)'"
              prop="palletLength"
            >
              <el-input-number
                v-model="formData.palletLength"
                :placeholder="
                  $l('form_placeholder_palletLength') || '请输入单托长(cm)'
                "
                controls-position="right"
                :step="1"
                :min="0"
                :max="9999999999"
                :precision="2"
                style="width:100%"
                @change="changePalletVolumes"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item
              :label="$l('form_label_palletWidth') || '单托宽(cm)'"
              prop="palletWidth"
            >
              <el-input-number
                v-model="formData.palletWidth"
                :placeholder="
                  $l('form_placeholder_palletWidth') || '请输入单托宽(cm)'
                "
                controls-position="right"
                :step="1"
                :min="0"
                :max="9999999999"
                :precision="2"
                style="width:100%"
                @change="changePalletVolumes"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item
              :label="$l('form_label_palletHeight') || '单托高(cm)'"
              prop="palletHeight"
            >
              <el-input-number
                v-model="formData.palletHeight"
                :placeholder="
                  $l('form_placeholder_palletHeight') || '请输入单托高(cm)'
                "
                controls-position="right"
                :step="1"
                :min="0"
                :max="9999999999"
                :precision="2"
                style="width:100%"
                @change="changePalletVolumes"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_palletGrossWeight') || '单托毛重KG'"
            >
              <el-input-number
                v-model="formData.palletGrossWeight"
                :placeholder="
                  $l('form_placeholder_palletGrossWeight') || '请输入单托毛重KG'
                "
                controls-position="right"
                :min="0"
                :precision="2"
                :step="0.1"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_palletNetWeight') || '单托净重KG'"
            >
              <el-input-number
                v-model="formData.palletNetWeight"
                :placeholder="
                  $l('form_placeholder_palletNetWeight') || '请输入单托净重KG'
                "
                controls-position="right"
                :min="0"
                :precision="2"
                :step="0.1"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_palletVolumes') || '单托体积立方米'"
            >
              <el-input-number
                v-model="formData.palletVolumes"
                :placeholder="
                  $l('form_placeholder_palletVolumes') || '请输入单托体积立方米'
                "
                controls-position="right"
                :min="0"
                :precision="2"
                :step="0.1"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_palletItemNo') || '箱唛ITEM号'"
            >
              <el-input
                v-model="formData.palletItemNo"
                :placeholder="
                  $l('form_placeholder_palletItemNo') || '请输入箱唛ITEM号'
                "
                maxlength="50"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$l('form_label_palletItemName') || '箱唛品名'"
            >
              <el-input
                v-model="formData.palletItemName"
                :placeholder="
                  $l('form_placeholder_palletItemName') || '请输入箱唛品名'
                "
                maxlength="100"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-descriptions
        border
        size="mini"
        class="bottom-desc"
        :column="3"
        v-if="disabled"
      >
        <el-descriptions-item
          :label="$l('descriptions_item_label_platformCode') || '出货渠道'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '268px', height: '32px' }"
          :span="1"
        >
          {{ formData.platformName }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_custCode') || '客户'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '268px', height: '32px' }"
          :span="2"
        >
          {{ formData.custName }}
        </el-descriptions-item>

        <el-descriptions-item
          :label="$l('descriptions_item_label_salesPerson') || '业务'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.salesPersonName }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_merchandiserCode') || '跟单'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.merchandiserName }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_ftyPersonName') || '工厂跟单'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.ftyPersonName }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_regionCode') || '运抵国'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.regionName }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_dispatchPort') || '出运港口'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.v_dispatchPort }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_bookingType') || '订舱类型'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.v_bookingType }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_containerName') || '出运箱型'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.containerName }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_inContainerQty') || '装柜入数'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.inContainerQty }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_inContainerUnit') || '入柜单位'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.v_inContainerUnit }}
        </el-descriptions-item>

        <el-descriptions-item
          :label="$l('form_label_palletLength') || '单托长(cm)'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.palletLength }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_palletWidth') || '单托宽(cm)'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.palletWidth }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_palletHeight') || '单托高(cm)'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.palletHeight }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_palletGrossWeight') || '单托毛重KG'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.palletGrossWeight }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_palletNetWeight') || '单托净重KG'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.palletNetWeight }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_palletVolumes') || '单托体积立方米'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '235px', height: '32px' }"
          :span="1"
        >
          {{ formData.palletVolumes }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_palletItemNo') || '箱唛ITEM号'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '268px', height: '32px' }"
          :span="1"
        >
          {{ formData.palletItemNo }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_palletItemName') || '箱唛品名'"
          :labelStyle="{ width: '120px', height: '32px' }"
          :contentStyle="{ width: '268px', height: '32px' }"
          :span="1"
        >
          {{ formData.palletItemName }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="packing-ratio-container mt-2">
      <SkuTable
        ref="skuTable"
        :evgPackingSchemeCode="evgPackingSchemeCode"
        :platformCode="formData.platformCode"
        :inContainerQty="formData.inContainerQty"
        :disabled="disabled"
      />
    </div>
    <div class="d-flex justify-content-end mb-2 mt-4">
      <el-button v-if="!disabled" type="primary" size="small" @click="save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import SkuTable from './sku-table'
import { multiply, divideRound } from '@/libs/util.number.js'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    evgPackingSchemeCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  components: { SkuTable },
  data() {
    return {
      formData: { custCode: '', custName: '', regionCode: '', regionName: '' },
      rules: {
        palletLength: [
          {
            required: true,
            message:
              this.$l('form_placeholder_palletLength') || '请输入单托长(cm)',
            trigger: 'blur',
          },
        ],
        palletWidth: [
          {
            required: true,
            message:
              this.$l('form_placeholder_palletWidth') || '请输入单托宽(cm)',
            trigger: 'blur',
          },
        ],
        palletHeight: [
          {
            required: true,
            message:
              this.$l('form_placeholder_palletHeight') || '请输入单托高(cm)',
            trigger: 'blur',
          },
        ],
        evgPackingSchemeName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_evgPackingSchemeName') ||
              '请输入大货包装方案名称',
            trigger: 'blur',
          },
        ],
        inContainerQty: [
          {
            required: true,
            message:
              this.$l('form_placeholder_inContainerQty') || '请输入装柜入数',
            trigger: 'blur',
          },
        ],
        salesPersonCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_salesPersonCode') || '请选择业务人员',
            trigger: 'blur',
          },
        ],
        merchandiserCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_merchandiserCode') || '请选择跟单',
            trigger: 'blur',
          },
        ],
        platformCode: [
          {
            required: true,
            message: this.$l('form_placeholder_platformCode') || '请选择渠道',
            trigger: 'blur',
          },
        ],
        ftyPersonCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_ftyPersonCode') || '请选择工厂跟单',
            trigger: 'blur',
          },
        ],
        dispatchPort: [
          {
            required: true,
            message:
              this.$l('form_placeholder_dispatchPort') || '请选择出运港口',
            trigger: 'blur',
          },
        ],
        bookingType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bookingType') || '请输入订舱类型',
            trigger: 'blur',
          },
        ],
        containerName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_containerName') || '请输入出运箱型',
            trigger: 'blur',
          },
        ],
        inContainerUnit: [
          {
            required: true,
            message:
              this.$l('form_placeholder_inContainerUnit') || '请选择入柜单位',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    reload() {
      this.getData()
      this.$refs.skuTable.getData()
    },
    async getData() {
      if (!this.evgPackingSchemeCode) return
      const res = await this.$api
        .ecomEvgPackingSchemeDetailApi({
          evgPackingSchemeCode: this.evgPackingSchemeCode,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    async validate() {
      const result = await validate.formValidate([this.$refs.form])
      const skuResult = await this.$refs.skuTable.validate()
      return result && skuResult
    },
    async save() {
      if (!(await this.validate())) return

      const listSku = this.$refs.skuTable.getTableData()
      const params = { ...this.formData, listSku }

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgPackingSchemeSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (!this.evgPackingSchemeCode) {
        this.$router.replace({
          name: 'ecom-evgBiz-evgPackagingScheme-detail',
          params: { code: body.evgPackingSchemeCode, pageType: 'edit' },
          query: { evgPackingSchemeNo: body.evgPackingSchemeNo },
        })
        return
      }

      this.reload()
    },
    async platformChange(platformCode) {
      // 清空产品信息
      this.$refs.skuTable.clear()

      if (!platformCode) return

      const res = await this.$api
        .ecomEvgPlatformDetailApi({ platformCode })
        .catch(() => null)
      const data = res?.body
      this.formData.custCode = data?.custCode || ''
      this.formData.custName = data?.custName || ''
      this.formData.regionCode = data?.regionCode || ''
      this.formData.regionName = data?.regionName || ''
    },
    changePalletVolumes() {
      this.formData.palletVolumes = divideRound(
        multiply(
          this.formData.palletLength,
          multiply(this.formData.palletWidth, this.formData.palletHeight)
        ),
        1000000,
        2
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.packing-scheme-container {
  margin-top: 20px;
  .title {
    height: 25px;
    line-height: 25px;
    font-weight: 600;
    color: #101010;
    font-size: 18px;
  }
  .base-info__form {
    margin-top: 15px;
  }
}
</style>
